module.exports = __webpack_public_path__ + "img/product5.c62a14aa.png";